import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { getToken } from '../../services/authToken';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

async function markBadgeSeen(slug) {
  const token = getToken();
  const res = await axios.post(
    `${API}/cabin/badges/${slug}/mark-seen`,
    {},
    { headers: token ? { Authorization: `Bearer ${token}` } : {} }
  );
  return res.data;
}

export function useMarkBadgeSeen() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: markBadgeSeen,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['cabin', 'badges'] });
    },
  });
}
